import { StateProvince } from "generated/graphql";

export { StateProvince as StateCode };

export const ALL_STATE_CODES: StateProvince[] = Object.values(StateProvince);
